import { fmtH } from "../../jornada";

const NOMBRE_DIA = ["lun", "mar", "mié", "jue", "vie", "sáb", "dom"];

// "lun-vie", "mar-sáb" o, si los días no son seguidos, "lun, mié, vie".
export function rangoDias(dias) {
  const ix = dias.map((h, i) => (h > 0 ? i : -1)).filter(i => i >= 0);
  if (!ix.length) return "sin días de trabajo";
  const seguidos = ix.every((d, k) => k === 0 || d === ix[k - 1] + 1);
  if (seguidos && ix.length > 1) return `${NOMBRE_DIA[ix[0]]}-${NOMBRE_DIA[ix[ix.length - 1]]}`;
  return ix.map(i => NOMBRE_DIA[i]).join(", ");
}

// "Jornada: 6 h/día · lun-vie · 30 h/sem"
export const lineaJornada = j =>
  `Jornada: ${fmtH(j.horas_dia).replace(" h", " h/día")} · ${rangoDias(j.dias)} · ${fmtH(j.horas_semana).replace(" h", " h/sem")}`;

// El motivo que manda el servidor está pensado para quien depura; aquí se dice en
// castellano y sin jerga.
export function explicarMotivo(motivo) {
  const m = String(motivo || "");
  let causa;
  if (/ambiguo|ya asignada/.test(m)) causa = "no hemos podido saber con seguridad qué ficha de Odoo es la tuya (el emparejamiento es ambiguo)";
  else if (/sin ficha/.test(m)) causa = "no hay una cuenta de Odoo emparejada con la tuya";
  else if (/no coherente|fuera de rango|siete dias|lineas dan/.test(m)) causa = "tu calendario de Odoo es incoherente (sus horas no cuadran)";
  else if (/no tiene calendario|no tiene lineas|no se puede leer|no se ha podido leer/.test(m)) causa = "no hemos podido leer un calendario de trabajo en Odoo";
  else causa = "no tenemos un calendario de trabajo fiable";
  return `Se usa el límite por defecto (8 h de lunes a viernes) porque ${causa}. Si no es tu jornada, pide a RRHH que revise tu calendario en Odoo.`;
}
